








































































































































import BaseVue from "@/core/BaseVue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import Telefono from "@/models/telefono.model";
import NameValue from "@/models/nameValue.model";
import moment from 'moment';
@Component({})
export default class TelefonoComponent extends BaseVue {
  @Prop() readonly personaId!: number;
  @Prop() readonly hideDefaultColumns!: boolean;
  

  telefono = new Telefono();
  editingTelefono: Telefono | null = null;
  editingTelefonoIndex = -1;
  telefonos: Telefono[] = [];
  tipoTelefono = new NameValue();
  //Telefonos
   getValueTime(value: string) {
    return moment(value).format("LT");
  }
  async addTelefono(tel: Telefono) {
    if (!tel) return;
    if (!tel.numero) return;

    var isValid = await this.$validator.validateAll();
    if (!isValid) {
      this.operationNoAllowed("Debe llenar tipo y número de teléfono");
      return;
    }

    if (this.telefonos.some(x => x.numero === tel.numero)) {
      this.operationNoAllowed("No se permiten teléfonos repetidos");
      return;
    }
    this.telefonos.push(this.telefono);
    this.telefono = new Telefono();
    this.$emit("change", this.telefonos);
  }
  
  removeTelefono(value: Telefono, index: number) {
    this.telefonos.splice(index, 1);
    this.$emit("change", this.telefonos);
  }
  editTelefono(value: Telefono, index: number) {
     var isValid = value.numero && value.numero.toString().length == 10 && value.tipoTelefonoNombre;
    if (!isValid) {
      this.operationNoAllowed("Debe llenar tipo y número de teléfono");
      return;
    }
    if (
      this.telefonos.some((x, i) => x.numero === value.numero && index != i)
    ) {
      this.operationNoAllowed("No se permiten telefonos repetidos");
      return;
    }
    if (value && value.numero) {
      this.telefonos.forEach((tel, inx) => {
        if (inx === index) tel.numero = value.numero;
      });
      //   this.model.telefonos.splice(index, 1, new Telefono(value));
    }

    this.editingTelefonoIndex = -1;
    this.editingTelefono = null;
    this.$emit("change", this.telefonos);
  }
  setTelefonoToEdit(props: any) {
    this.editingTelefonoIndex = props.index;
    this.editingTelefono = props.row;
    // var input = this.$refs[props.row.numero + props.index] as any;
    // input.focus();
  }
}
